export default __webpack_public_path__ + "static/audio-cardio-5-f-c7330e55276d0d02b517e2b147ca3461.webp";